import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from '../js/use-click-outside';

export default class extends Controller {
	connect() {
		useClickOutside(this, {elements: [this.element]})
	}

	clickOutside() {
		this.dispatch("click");
	}
}
